<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ isEditing ? 'Editar Usuário' : 'Visualizar Usuário' }}</h4>
            
            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando usuário...</span>
              </div>
              <p class="mt-2">Carregando dados do usuário...</p>
            </div>

            <div v-else-if="!userId" class="alert alert-danger">
              <i class="ri-error-warning-line"></i>
              ID do usuário não fornecido. 
              <router-link to="/admin/users" class="alert-link">Voltar para lista de usuários</router-link>
            </div>

            <form v-else @submit.prevent="updateUser">              
              
              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    id="example-name"
                    label="Nome Completo *"
                    label-for="name"
                    :invalid-feedback="errors.name"
                    :state="errors.name ? false : null"
                  >
                    <b-form-input
                      id="name"
                      v-model="form.name"
                      type="text"
                      required
                      placeholder="Digite o nome completo"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    id="example-email"
                    label="Email *"
                    label-for="email"
                    :invalid-feedback="errors.email"
                    :state="errors.email ? false : null"
                  >
                    <b-form-input
                      id="email"
                      v-model="form.email"
                      type="email"
                      required
                      placeholder="Digite o email"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    id="example-role"
                    label="Tipo de Usuário *"
                    label-for="role"
                    :invalid-feedback="errors.role"
                    :state="errors.role ? false : null"
                  >
                    <b-form-select
                      id="role"
                      v-model="form.role"
                      :options="roleOptions"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    id="example-cpf"
                    label="CPF"
                    label-for="cpf"
                  >
                    <b-form-input
                      id="cpf"
                      v-model="form.cpf"
                      v-mask="'###.###.###-##'"
                      type="text"
                      placeholder="000.000.000-00"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    id="example-cbo"
                    label="CBO"
                    label-for="cbo"
                  >
                    <b-form-input
                      id="cbo"
                      v-model="form.cbo"
                      v-mask="'######'"
                      type="text"
                      placeholder="000000"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    id="example-crm"
                    label="CRM"
                    label-for="crm"
                  >
                    <b-form-input
                      id="crm"
                      v-model="form.crm"
                      v-mask="'#######'"
                      type="text"
                      placeholder="0000000"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    id="example-especialidade-codigo"
                    label="Código da Especialidade"
                    label-for="especialidade_codigo"
                  >
                    <b-form-input
                      id="especialidade_codigo"
                      v-model="form.especialidade_codigo"
                      v-mask="'####'"
                      type="text"
                      placeholder="0000"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    id="example-especialidade-nome"
                    label="Nome da Especialidade"
                    label-for="especialidade_nome"
                  >
                    <b-form-input
                      id="especialidade_nome"
                      v-model="form.especialidade_nome"
                      type="text"
                      placeholder="Nome da especialidade médica"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    id="example-is-active"
                    label="Status do Usuário"
                  >
                    <b-form-checkbox
                      id="is_active"
                      v-model="form.is_active"
                    >
                      Usuário Ativo
                    </b-form-checkbox>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    id="example-is-superuser"
                    label="Permissões"
                  >
                    <b-form-checkbox
                      id="is_superuser"
                      v-model="form.is_superuser"
                    >
                      Super Usuário
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div>

              <!-- Seção de Reset de Senha -->
              <div class="row mt-4">
                <div class="col-12">
                  <h5>Alterar Senha</h5>
                  <hr>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    id="example-new-password"
                    label="Nova Senha"
                    label-for="new_password"
                    :invalid-feedback="errors.new_password"
                    :state="errors.new_password ? false : null"
                    description="Mínimo 6 caracteres. Deixe em branco para não alterar."
                  >
                    <b-form-input
                      id="new_password"
                      v-model="passwordForm.new_password"
                      type="password"
                      placeholder="Deixe em branco para manter a senha atual"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Ou gerar senha temporária</label>
                    <div>
                      <button
                        type="button"
                        class="btn btn-outline-warning"
                        @click="generateTempPassword"
                        :disabled="submitting"
                      >
                        <i class="ri-key-2-line"></i> Gerar Senha Temporária
                      </button>
                    </div>
                    <small class="form-text text-muted">
                      Gera uma senha temporária automaticamente
                    </small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between">
                    <router-link to="/admin/users" class="btn btn-secondary">
                      <i class="ri-arrow-left-line"></i> Voltar
                    </router-link>
                    
                    <div>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        :disabled="submitting"
                      >
                        <i v-if="submitting" class="spinner-border spinner-border-sm me-2"></i>
                        <i v-else class="ri-save-line"></i>
                        {{ submitting ? 'Salvando...' : 'Salvar Alterações' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { adminService } from "@/api/admin";

export default {
  name: "EditUser",
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Editar Usuário",
      items: [
        {
          text: "Administração",
          href: "/admin",
        },
        {
          text: "Usuários",
          href: "/admin/users",
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      loading: false,
      submitting: false,
      isEditing: true,
      userId: null,
      roleOptions: [
        { value: "", text: "Selecione um tipo" },
        { value: "ADMIN", text: "Administrador" },
        { value: "DOCTOR", text: "Médico" },
        { value: "TECHNICIAN", text: "Técnico" },
        { value: "PATIENT", text: "Paciente" }
      ],
      form: {
        name: "",
        email: "",
        role: "",
        cpf: "",
        cbo: "",
        crm: "",
        especialidade_codigo: "",
        especialidade_nome: "",
        is_active: true,
        is_superuser: false,
      },
      passwordForm: {
        new_password: "",
      },
      errors: {},
    };
  },
  async created() {
    this.userId = this.$route.params.id;
    
    if (!this.userId) {
      this.$showError("ID do usuário não fornecido");
      this.$router.push("/admin/users");
      return;
    }
    
    await this.loadUser();
  },
  watch: {
    form: {
      handler(newVal) {
        console.log("Form alterado:", newVal);
      },
      deep: true
    }
  },
  methods: {
    async loadUser() {
      this.loading = true;
      try {
        const response = await adminService.getUserById(this.userId);
        
        // Extrair os dados do usuário da resposta
        const user = response.data || response;
        
        // Preencher o formulário com os dados do usuário
        this.form.name = user.name || "";
        this.form.email = user.email || "";
        this.form.role = user.role || "";
        this.form.cpf = user.cpf || "";
        this.form.cbo = user.cbo || "";
        this.form.crm = user.crm || "";
        this.form.especialidade_codigo = user.especialidade_codigo || "";
        this.form.especialidade_nome = user.especialidade_nome || "";
        this.form.is_active = user.is_active === true;
        this.form.is_superuser = user.is_superuser === true;
        
        console.log("Formulário preenchido:", this.form);
        console.log("Valores dos checkboxes - is_active:", this.form.is_active, "is_superuser:", this.form.is_superuser);
        
        // Aguardar próximo tick do Vue para garantir atualização do DOM
        await this.$nextTick();
        
        // Atualizar título
        this.title = `Editar Usuário - ${user.name || user.email}`;
        
      } catch (error) {
        console.error("Erro ao carregar usuário:", error);
        this.$handleApiError(error);
        this.$router.push("/admin/users");
      } finally {
        this.loading = false;
      }
    },

    async updateUser() {
      this.submitting = true;
      this.errors = {};

      try {
        // Preparar dados para atualização (apenas campos preenchidos)
        const updateData = {};
        
        Object.keys(this.form).forEach(key => {
          const value = this.form[key];
          if (value !== null && value !== undefined && value !== "") {
            updateData[key] = value;
          }
        });

        // Se há uma nova senha, incluí-la
        if (this.passwordForm.new_password && this.passwordForm.new_password.trim()) {
          updateData.password = this.passwordForm.new_password.trim();
        }

        await adminService.updateUser(this.userId, updateData);
        
        this.$showSuccess("Usuário atualizado com sucesso!");
        
        // Limpar campo de senha
        this.passwordForm.new_password = "";
        
        // Recarregar os dados
        await this.loadUser();
        
      } catch (error) {
        console.error("Erro ao atualizar usuário:", error);
        this.$handleApiError(error);
        
        // Tratar erros de validação
        if (error.response && error.response.data && error.response.data.detail) {
          const detail = error.response.data.detail;
          if (typeof detail === 'object') {
            this.errors = detail;
          }
        }
      } finally {
        this.submitting = false;
      }
    },

    async generateTempPassword() {
      if (!confirm("Tem certeza que deseja gerar uma nova senha temporária para este usuário?")) {
        return;
      }

      this.submitting = true;
      try {
        const response = await adminService.resetUserPassword(this.userId);
        
        if (response.temporary_password) {
          this.$showSuccess(
            `Senha temporária gerada: ${response.temporary_password}\nComunique esta senha ao usuário.`,
            { 
              variant: 'warning',
              autoHideDelay: 10000
            }
          );
        } else {
          this.$showSuccess("Senha temporária gerada com sucesso!");
        }
        
      } catch (error) {
        console.error("Erro ao gerar senha temporária:", error);
        this.$handleApiError(error);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
